import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateDictionaryItem = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.dictionaryUpdateItem,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) => typeof query.queryKey[0] === 'string' && query.queryKey[0].includes('/dictionaries'),
      });
    },
  });
};
